import React from 'react';
import {LoginDispacher, UserApp} from './AuthProviderActions';

const user:UserApp = localStorage.getItem('currentUser')
    ? JSON.parse( localStorage.getItem('currentUser') + '' ).user
    : {};

const company:CompanyApp = localStorage.getItem('currentUser')
    ? JSON.parse( localStorage.getItem('currentUser') + '' ).company
    : '';

const token:string = localStorage.getItem('currentUser')
    ? JSON.parse( localStorage.getItem('currentUser') + '' ).token
    : '';

export interface CompanyApp {
    id: number,
    name: string,
    isMigrated: boolean,
}

export interface LoginPayload { //HNResponse
    user?:            UserApp
    company?:      CompanyApp,
    token?:          string,
    loading?:        boolean,
    errorMessage?:   string,
}

export const initialState:LoginPayload = {
    user:         user,
    token:        token,
    loading:      false,
    errorMessage: undefined,
    company: company
};

export const AuthReducer: React.Reducer<LoginPayload, LoginDispacher> = (initialState: LoginPayload, action: LoginDispacher): LoginPayload => {
    switch (action.type) {
        case 'REQUEST_LOGIN':
            return {
                ...initialState,
                loading: true
            };
        case 'LOGIN_SUCCESS': {
            const copy = {
                ...initialState,
                loading: false,
                errorMessage: undefined
            };
            if (action.payload !== undefined) {
                copy.user = action.payload?.user;
                copy.token = action.payload?.token;
                copy.company = action.payload?.company;
            }

            return copy;
        }
        case 'LOGOUT':
            return {
                ...initialState,
                user: undefined,
                token: '',
                loading: true,
                errorMessage:undefined
            };

        case 'LOGOUT_SUCCESS':
            return {
                ...initialState,
                loading: false,
            };

        case 'LOGIN_ERROR':
            return {
                ...initialState,
                loading: false,
                errorMessage: action.error
            };

        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};
